import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';

import WhalersClubRewardHistory from '../WhalersClubRewardHistory/WhalersClubRewardHistory';
import { useStyles } from './ConnectedWhalersClubRewardHistoryModal.styles';
import { useWhalersClubRewardHistory } from '../../hooks/useWhalersClubRewardHistory';

interface ConnectedWhalersClubRewardHistoryModalProps {
  isOpen: boolean;
  isClosing: boolean;
  onClose: () => void;
  programId: string;
}

function ConnectedWhalersClubRewardHistoryModal({
  isOpen,
  isClosing,
  onClose,
  programId,
}: ConnectedWhalersClubRewardHistoryModalProps) {
  const { classes } = useStyles();

  const {
    activePeriod,
    availablePeriods,
    rewardHistoryRecords,
    isLoading,
    handleMonthChange,
  } = useWhalersClubRewardHistory(programId);

  return (
    <Dialog
      type={{ desktop: 'modal', mobile: 'modal-full-screen' }}
      isOpen={isOpen}
      isClosing={isClosing}
      onClose={onClose}
      className={classes.dialogContainer}
    >
      <DialogBody className={classes.dialogBody}>
        <WhalersClubRewardHistory
          activePeriod={activePeriod}
          isLoading={isLoading}
          records={rewardHistoryRecords}
          availablePeriods={availablePeriods}
          handleMonthChange={handleMonthChange}
        />
      </DialogBody>
    </Dialog>
  );
}

export default ConnectedWhalersClubRewardHistoryModal;
